module.exports = {
URL: function (f,tamanyo) {
  var r = "/"+tamanyo+"/"+f.y+"/"+f.m+"/"+f.d+"/"+f.g+"/"+f.i+".jpg";
  return r;
  },
fecha: function(f) {
  return f.y+"-"+f.m+"-"+f.d+" "+f.h;
  },
};
